import { type FC } from 'react';
import { BaseEdge, getBezierPath, type EdgeProps } from 'reactflow';
import type { LinkData } from '@/types/link.types';

const DEPENDENCY_COLOR = '#9CA3AF';

export const DependencyEdge: FC<EdgeProps<LinkData>> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  style,
}) => {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  return (
    <BaseEdge
      id={id}
      path={edgePath}
      markerEnd={markerEnd}
      style={{
        stroke: DEPENDENCY_COLOR,
        strokeWidth: 2,
        strokeDasharray: '8 4',
        ...style,
      }}
    />
  );
};

export default DependencyEdge;
